import { InterfaceReducer } from '@leverege/api-redux'
import { GlobalState } from '@leverege/ui-redux'
import InterfaceActions from '@leverege/api-redux/lib/interface/InterfaceActions'
import { AbstractGroupDelegate } from '@leverege/molten/data-source'
import Can from '@leverege/api-redux/lib/interface/Can'

export default class EventsGroupDelegate extends AbstractGroupDelegate {
  static TYPE = 'imagine.EventsGroupDelegate'

  constructor( options ) {
    super( options )
    const { match, relationship, filter, queryName, ...rest } = options
    this.type = EventsGroupDelegate.TYPE
    this.relationship = relationship.isResolved ? relationship : relationship.createResolved( match )
    this.systemId = relationship.systemId
    this.id = relationship.id
    this.options = rest
    this.can = new Can( this.getInterfaceUrl(), !relationship.parent, true )
  }

  getInterfaceUrl() {
    return this.relationship.ref
  }

  getParentInterfaceUrl() {
    const parent = this.relationship.parent
    return parent ? parent.createItem( this.match ).objRefUrl : null
  }

  search( query, options ) {
    const url = this.getInterfaceUrl( )
    const pUrl = this.getParentInterfaceUrl()
    
    return InterfaceActions.getHistory( `${url}.events`, pUrl, { ...options, q : JSON.stringify( query.query ) }, query.queryName )
  }

  canList( state = GlobalState.get(), requestIfUnavailable = true ) {
    const can = this.can.getHistory( state )
    if ( can == null && requestIfUnavailable ) {
      GlobalState.dispatch( this.requestCanHistory( ) )
    }
    return can
  }

  requestCanList( query ) {
    return this.can.history( query )
  }

  // eslint-disable-next-line
  getList( state = GlobalState.get(), queryName, options ) {
    return InterfaceReducer.getHistory( state, `${this.getInterfaceUrl()}.events`, queryName, options )
  }
}
